/* template */
<template minapp="mpx" xlang="wxml"><mpx-view :class="(hasBottomMargin ? 'bottom':'')" @tap="didClick" class="info-content"><span class="title">{{ title }}</span><slot v-if="(useSlot)"/><span :style="[(valueStyle)] | transRpxStyle" class="value" v-else>{{ value }}</span><es-icon name="angle-right" size="20" color="#999999" class="arrow" v-if="(hasArrow)"/></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"maaf95858"}'>
  .info-content
    display flex
    justify-content flex-start
    font-size 14px
  .bottom
    margin-bottom 12px
  .title
    flex 0 0 70px
    color #999999
  .value
    flex 1
    color #333333
    white-space pre-wrap
  .arrow
    margin-left auto
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "maaf95858"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-inline-info.mpx.js?isComponent&outputPath=components%2Forder-inline-infoaaf95858%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-inline-info.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Forder-inline-infoaaf95858%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["maaf95858"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/order-inline-infoaaf95858/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
